// Arama motoru indeksleme politikasi.
//
// Site yalnizca asagidaki domainlerden (www'lu ve www'suz hali) yayinlandiginda
// indekslenir. Bunlarin disindaki her host (subdomain, staging, preview, IP vb.)
// noindex alir.

const INDEXABLE_DOMAINS = ["altinkaynak.com"];

// Canonical'in hangi host uzerinden verilecegi. Su an hem altinkaynak.com hem
// www.altinkaynak.com 200 donuyor (aralarinda redirect yok); asil adres www'suz
// olacaksa bu degeri "" yapmak yeterli.
const CANONICAL_PREFIX = "www.";

const INDEXABLE_HOSTS = new Set(
  INDEXABLE_DOMAINS.flatMap((domain) => [domain, `www.${domain}`])
);

const normalizeHost = (hostname) =>
  (hostname || "").toLowerCase().replace(/\.$/, "");

export const isIndexableHost = (hostname) =>
  INDEXABLE_HOSTS.has(normalizeHost(hostname));

const upsertMeta = (attrName, attrValue, content) => {
  if (typeof document === "undefined") return;
  const selector = `meta[${attrName}="${attrValue}"]`;
  let meta = document.head.querySelector(selector);
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute(attrName, attrValue);
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", content);
};

// Bir subdomain'de bile olsak canonical'i ait oldugu ana domaine yonlendirir.
const canonicalDomainFor = (hostname) => {
  const host = normalizeHost(hostname);
  return INDEXABLE_DOMAINS.find(
    (domain) => host === domain || host.endsWith(`.${domain}`)
  );
};

export const applyIndexingPolicy = () => {
  if (typeof document === "undefined" || typeof window === "undefined") return;

  const { hostname, pathname } = window.location;
  const content = isIndexableHost(hostname)
    ? "index, follow"
    : "noindex, nofollow, noarchive";

  upsertMeta("name", "robots", content);
  upsertMeta("name", "googlebot", content);
  upsertMeta("name", "bingbot", content);

  const domain = canonicalDomainFor(hostname);
  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!domain) {
    // Tanimsiz bir host (ornegin preview/IP): canonical vermeyelim.
    if (canonical) canonical.remove();
    return;
  }
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", `https://${CANONICAL_PREFIX}${domain}${pathname}`);
};
